// NOTE - this needs to be moved into ux-tread-cart-redux (partnercart-redux should be folded into cart-redux, but keep tread-partnercart separate)
import { createSelector } from 'reselect';
import getFilteredCartErrors from './get-filtered-cart-errors';
import { getFilteredCartWarnings } from '../features/cart/selectors';

const getHasCartErrorsOrWarnings = createSelector(
  getFilteredCartErrors,
  getFilteredCartWarnings,
  (errors, warnings) => errors.length > 0 || warnings.length > 0,
);

export default getHasCartErrorsOrWarnings;
